import styled, { css } from 'styled-components';

export const Sticky = styled.div`
  width: 100%;
  position: sticky;
  top: ${({ bound }) => `${bound}px`};
  z-index: 1;
`;

export const DropdownNavWrapper = styled.div`
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const StyledDropdownNav = styled.div`
  position: relative;
  font-weight: bold;
  z-index: 1;
  perspective: 400px;
`;

export const SelectedItem = styled.div`
  padding: 10px;
  border: 1px solid;
  border-radius: 7px;
  position: relative;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.orange};
  border-color: ${({ theme }) => theme.colors.blue};

  ::before {
    content: ' ';
    position: absolute;
    top: 16px;
    right: 10px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid ${({ theme }) => theme.colors.blue};
  }

  opacity: 0;
  pointer-events: none;
  transform-origin: 50% 0;
  transform: rotate3d(1, 0, 0, 90deg);
  transition-property: opacity transform;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;

  ${({ isOpen }) =>
    !isOpen &&
    css`
      opacity: 1;
      pointer-events: all;
      transform: rotate3d(1, 0, 0, 0);
    `};

  > * {
    padding: 10px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  border: 1px solid;
  border-radius: 7px;
  border-color: ${({ theme }) => theme.colors.blue};
  background-color: ${({ theme }) => theme.colors.white};

  opacity: 0;
  pointer-events: none;
  transform-origin: 50% 0;
  transform: translate3d(0, 40px, 0) rotate3d(1, 0, 0, -90deg);
  transition-property: opacity transform;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      pointer-events: all;
      transform: translate3d(0, 0, 0) rotate3d(1, 0, 0, 0);
    `};

  > * {
    padding: 10px;
  }
`;

export const Option = styled.div`
  color: ${({ theme }) => theme.colors.blue};
  cursor: pointer;
`;

export const DropdownTitle = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.orange};

  ::before {
    content: ' ';
    position: absolute;
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
  }
`;
